import { combineReducers } from 'redux'
import { reducer as disabledBureaux } from './getDisabledBureaux'
import { reducer as allBureaux } from './getAllBureaux'
import { reducer as addBureau } from './addBureau'
import { reducer as editBureau } from './editBureau'
import { reducer as deleteBureau } from './deleteBureau'

export default combineReducers({
    allBureaux,
    disabledBureaux,
    editBureau,
    deleteBureau,
    addBureau,
})
